import React, {useState} from 'react';
import { Button } from "@material-ui/core";
// @ts-ignore
import { FilePicker } from "react-file-picker";
import clsx from "clsx";
import {CrossButtonBlack} from "components/Buttons/CrossButton";

import {useActionApi, usePersistedApi} from "hooks";
import Api from "api";
import entities from "reduxStore/entityKeys";
import {UserAccountProps} from "utils/types";
import Popup from 'components/Popup';

import { Container, StyledDescriptionOutlinedIcon, ErrorMessage } from "./UploadResumeButton.styles";
import styles from "pages/landing/SignUp2_Talent/components/components.module.scss";

const getErrorType = (error: string) => {
  if (error) {
    return error.split(' ')[0] === 'Must' ? 'extension' : 'size';
  }
}

interface UploadResumeButtonProps {
  onResumeUploaded?: () => Promise<void>
}

const UploadResumeButton = ({onResumeUploaded}: UploadResumeButtonProps) => {
  const [uploadError, setUploadError] = useState<string | undefined>();
  const [showMobileModal, setShowMobileModal] = useState(false);
  const isMobile = !!window.cordova;

  const [
    hygienistUserUpdated,
    hygienistUserLoading,
    hygienistUserError,
    getHygienistUser
  ] = usePersistedApi({
    apiMethod: Api.getUser,
    entityName: entities.user,
    initialValue: {} as UserAccountProps
  })

  const hireResumeUrl = hygienistUserUpdated?.hygienist?.hireResumeUrl

  const [pdfLoading, pdfError, uploadPDF] = useActionApi({
    apiMethod: Api.uploadPDF,
    onSuccess: () => {
      setUploadError(undefined)
      getHygienistUser({});
      onResumeUploaded && onResumeUploaded();
    },
  })

  const buttonLabel = hireResumeUrl ? 'Edit Resumé' : 'Upload Resumé';

  const handleButtonClick = () => {
    if (isMobile) {
      setShowMobileModal(true);
    }
  }

  return (
    <Container>
     
        <FilePicker
          extensions={['pdf', 'docx', 'doc', 'png', 'tiff', 'jpg', 'jpeg']}
          onChange={uploadPDF}
          onError={(error: string) => {
            setUploadError(error)
          }}
          className="no-fastclick"
        >
          <Button
            variant="contained"
            startIcon={<StyledDescriptionOutlinedIcon/>}
            color="primary"
            disabled={pdfLoading}
            size="large"
            id="add-new-job-button"
            className={clsx("bigButtonInNewStyle", "no-fastclick")}
          >
            {pdfLoading ? 'Uploading...' : buttonLabel}
          </Button>
        </FilePicker>
    
      <ErrorMessage>
        {
          uploadError
            ? getErrorType(uploadError) === 'extension' ? 'To upload your resume, please select an image (JPG), Word, or PDF document format.' : uploadError
            : pdfError ? 'Oops, something went wrong...' : null
        }
      </ErrorMessage>
    </Container>
  );
}

export default UploadResumeButton;